module.exports = __webpack_public_path__ + "static/media/SadeepaGunawardana.2f824b81.png";